__turbopack_context__.v({
  "className": "oswald_5612efd3-module__3xEZwa__className",
});
